import { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Alert, CircularProgress, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useChangeState } from '../../hooks';

export interface Props {
  strategyId: string;
  isOpen: boolean;
  onUpdate: () => void;
  onClose: () => void;
}

export function VisibilityDialog({ strategyId, isOpen, onUpdate, onClose }: Props) {
  const [error, setError] = useState('');

  const { mutateAsync, isPending: isLoading } = useChangeState();

  const onSubmit = async () => {
    const data = {
      id: strategyId,
      open: isOpen,
    };

    try {
      const result = await mutateAsync(data);

      if (result.errorMessage) {
        setError(result.errorMessage);
        return;
      }

      onUpdate();
    } catch (err) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      setError(err?.message || 'Произошла непредвиденная ошибка');
    }
  };

  return (
    <Dialog maxWidth="xs" open>
      <DialogTitle align="center">Изменение видимости стратегии</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        Вы уверены, что хотите сделать инвест-копилку {isOpen ? 'закрытой' : 'открытой'}?
        <br />
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
          Отмена
        </Button>
        <Button onClick={onSubmit} disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
          Ок
        </Button>
      </DialogActions>
    </Dialog>
  );
}
